// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BlockPay_Wrapper__wWXuC","Title":"BlockPay_Title__JH1mo","Value":"BlockPay_Value__FvEq4"};